import { styled, Typography, TypographyProps } from '@mui/material';
import clsx from 'clsx';
import { forwardRef } from 'react';

// eslint-disable-next-line react-refresh/only-export-components
export const dialogLabelClasses = {
  root: 'MdsDialogLabel',
};

const DialogLabelRoot = styled(Typography, {
  name: 'MuiDialogLabel',
  slot: 'Root',
})(({ theme }) => ({
  padding: theme.spacing(3, 3, 1),
  flex: '0 0 auto',
})) as typeof Typography;

export const DialogLabel = forwardRef<HTMLSpanElement, TypographyProps>(function DialogLabel(props, ref) {
  return (
    <DialogLabelRoot
      component="span"
      color="textSecondary"
      ref={ref}
      variant="label2"
      {...props}
      className={clsx(dialogLabelClasses.root, props.className)}
    />
  );
});
